import { FC } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';

import {
  AuthPage,
  AuthRedirectPage,
  HomePage,
  PageNotFound,
  ErrorPage,
  FundingCalculatorPage,
  FundingCalculatorLandingPage,
  SignupPage,
  PendingAccess,
  PendingCompanyAccess,
  RejectedAccess,
  ExpiredInvitationAccess,
  InvalidInvitationAccess,
  DeepLinkRedirectPage,
} from '../pages';
import DemoSignupPage from '../pages/Demo/SignupPage/SignupPage';
import { ProtectedLayout, AccessRequestLayout } from '../layouts';
import { LinkValidityGuard } from '../components';
import PrivateRoutes from './PrivateRoutes';
import ShareRoutes from './ShareRoutes';
import { NAV_ROUTES } from '../constants/navRoutes';
import usePageTitle from '@hooks/usePagetitle';

const PublicRoutes: FC = () => {
  usePageTitle();
  const location = useLocation();

  return (
    <LinkValidityGuard>
      <Routes>
        <Route path={NAV_ROUTES.AUTH} element={<AuthPage />} />
        <Route path={NAV_ROUTES.AUTH_REDIRECT} element={<AuthRedirectPage />} />
        <Route path={NAV_ROUTES.PAGE_NOT_FOUND} element={<PageNotFound />} />
        <Route path={NAV_ROUTES.HOME} element={<HomePage />} />
        <Route path={NAV_ROUTES.ERROR} element={<ErrorPage />} />
        <Route path={NAV_ROUTES.FUNDING_CALCULATOR} element={<FundingCalculatorLandingPage />} />
        <Route
          path={NAV_ROUTES.FUNDING_CALCULATOR_PLAYGROUND}
          element={<FundingCalculatorPage isPlayground={true} />}
        />
        <Route
          path={NAV_ROUTES.FUNDING_CALCULATOR_DETAILS}
          element={<FundingCalculatorPage isPlayground={false} />}
        />
        <Route
          path={NAV_ROUTES.FUNDING_CALCULATOR_DETAILS_ID}
          element={<FundingCalculatorPage isPlayground={false} />}
        />
        <Route path={NAV_ROUTES.SIGNUP} element={<SignupPage />} />
        <Route path={NAV_ROUTES.DEMO_SIGNUP} element={<DemoSignupPage />} />
        <Route path={NAV_ROUTES.DEEP_LINK_REDIRECT} element={<DeepLinkRedirectPage />} />
        <Route path={NAV_ROUTES.ACCESS_INVITATION_EXPIRED} element={<ExpiredInvitationAccess />} />
        <Route path={NAV_ROUTES.ACCESS_INVITATION_INVALID} element={<InvalidInvitationAccess />} />
        <Route
          path="/"
          element={<Navigate to={{ pathname: NAV_ROUTES.HOME, search: location.search }} replace />}
        />

        {/* Share routes */}
        {ShareRoutes}

        <Route element={<AccessRequestLayout />}>
          <Route path={NAV_ROUTES.ACCESS_PENDING} element={<PendingAccess />} />
          <Route path={NAV_ROUTES.ACCESS_COMPANY_PENDING} element={<PendingCompanyAccess />} />
          <Route path={NAV_ROUTES.ACCESS_REJECTED} element={<RejectedAccess />} />
        </Route>

        <Route element={<ProtectedLayout />}>
          <Route path="/*" element={<PrivateRoutes />} />
        </Route>
      </Routes>
    </LinkValidityGuard>
  );
};

const AppRoutes: FC = () => (
  <Router>
    <PublicRoutes />
  </Router>
);

export default AppRoutes;
